<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttLabel="businessco_companyname" [ttModel]="menu.businessco_companyname" ttReadonly></tt-input>
            <tt-input ttLabel="invoicemethod_name" [ttModel]="menu.invoicemethod_name" ttReadonly></tt-input>
            <tt-input ttLabel="cust_name" [ttModel]="menu.cust_name" ttReadonly></tt-input>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListMultiOrders" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="invoicemakemultiorders_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="40">
                    <tt-card>
                        <tt-input ttLabel="businessco_companyname" [ttModel]="menu.businessco_companyname" ttReadonly></tt-input>
                        <tt-input ttLabel="invoicemethod_name" [ttModel]="menu.invoicemethod_name" ttReadonly></tt-input>
                        <tt-input ttLabel="cust_name" [ttModel]="menu.cust_name" ttReadonly></tt-input>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="60">
                    <tt-list-legacy [listItems]="itemsListMultiOrders" ltype="multi" typevar="g"></tt-list-legacy>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
